import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { MaterialReactTable } from "material-react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import { FilterComponent, useSimpleTableConfig } from "../../../constants";
import { dataMonitoreo2025 } from "../../../data/2025/dataMonitoreo2025.js";

const baseUrl = "https://itetlax.org.mx/assets/pdf/monitoreos/2025/";

const PdfLink = ({ id }) => {
  const fullUrl = `${baseUrl}${id}.pdf`;
  return (
    <a href={fullUrl} target="_blank" rel="noreferrer">
      <FontAwesomeIcon icon={faFilePdf} className="btn btn-danger" />
    </a>
  );
};

const renderCellPDF = ({ cell }) => <PdfLink id={cell.getValue()} />;

const Monitoreos2025 = () => {
  useEffect(() => {
    document.title = `Monitoreos 2025`;
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "monthBoletin",
        header: "MES",
        Filter: FilterComponent,
        size: 50,
      },
      {
        accessorKey: "nameBoletin",
        header: "BOLETÍN",
      },
      {
        accessorKey: "id",
        header: "DESCARGAR",
        enableColumnFilters: false,
        Cell: renderCellPDF,
      },
    ],
    []
  );

  const table = useSimpleTableConfig(dataMonitoreo2025, columns);

  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[
            { label: "Comunicación Social" },
            { label: "Monitoreos", url: "/Monitoreo" },
            { label: `Monitoreos 2025` },
          ]}
        />
        <TitlePages title="Comunicación Social" subTitle="Monitoreos 2025" />
        
        <div>
          <TitlePages 
            title="" 
            subTitle="Informes de monitoreo de medios de comunicación masiva 2025." 
          />
        </div>
        
        <MaterialReactTable table={table} />
      </div>
    </>
  );
};

export default Monitoreos2025;

PdfLink.propTypes = {
  id: PropTypes.number.isRequired,
};